<template>
  <div class="product-container">
    <div class="layout-banner">
      <img
        src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/product_pvlayout_banner.png"
        class="pc-banner"
        alt=""
      />
      <div class="text-block">
        <div
          class="title wow fadeInUp"
          data-wow-duration="0.8s"
          data-wow-delay="0.2s"
        >
          光伏一点通-电站设计评估系统
        </div>
        <div class="desc wow fadeInUp" data-wow-delay="0.5s">
          让电站开发更简单
        </div>
        <div
          class="use-button wow fadeInUp"
          @click="toPage"
          data-wow-delay="0.7s"
        >
          点击使用
        </div>
      </div>
    </div>

    <div class="block-wrap product-block">
      <div class="block-title page-block-title">产品简介</div>
      <div class="block-desc page-block-desc">
        在分布式光伏电站前期开发过程中，通过卫星或无人机快速获取屋顶现状数据，
        高效完成光伏组件排布设计。基于专业财务分析评估模型，生成电站商务洽谈方案和可行性分析报告，有效提升光伏电站开发建设投资效率。
      </div>
      <div class="block-content-row">
        <div class="column-item">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/product_icon1.png"
            alt=""
          />
          <div class="text-block">
            <div class="product-title">商机筛查</div>
            <div class="product-desc">
              踏勘方案一触即达
              <div>商机分析分秒可得</div>
            </div>
          </div>
        </div>
        <div class="column-item">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/product_icon2.png"
            alt=""
          />
          <div class="text-block">
            <div class="product-title">容量测算</div>
            <div class="product-desc">
              踏勘数据云端计算
              <div>容量测算精准可靠</div>
            </div>
          </div>
        </div>
        <div class="column-item">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/product_icon3.png"
            alt=""
          />
          <div class="text-block">
            <div class="product-title">收益评估</div>
            <div class="product-desc">
              专业模型测算成本收益
              <div>简单飞行完成财务评估</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 主要功能 -->
    <div class="block-wrap bg-wrap">
      <div class="block-title page-block-title">主要功能</div>
      <div class="function-list">
        <div class="function-column">
          <div class="img-wrap">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/function_icon1.png"
              alt=""
            />
          </div>
          <div class="text">项目管理</div>
        </div>

        <div class="function-column">
          <div class="img-wrap">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/function_icon2.png"
              alt=""
            />
          </div>
          <div class="text">卫星踏勘</div>
        </div>

        <div class="function-column">
          <div class="img-wrap">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/function_icon3.png"
              alt=""
            />
          </div>
          <div class="text">无人机踏勘</div>
        </div>

        <div class="function-column">
          <div class="img-wrap">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/function_icon4.png"
              alt=""
            />
          </div>
          <div class="text">组件排布</div>
        </div>

        <div class="function-column">
          <div class="img-wrap">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/ele_design_icon5.png"
              alt=""
            />
          </div>
          <div class="text">电气设计</div>
        </div>

        <!-- <div class="function-column">
          <div class="img-wrap">
            <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/function_icon6.png" alt="" />
          </div>
          <div class="text">荷载评估</div>
        </div> -->

        <div class="function-column">
          <div class="img-wrap">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/cad_icon.png"
              alt=""
            />
          </div>
          <div class="text">CAD图纸</div>
        </div>

        <div class="function-column">
          <div class="img-wrap">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/function_icon8.png"
              alt=""
            />
          </div>
          <div class="text">安装效果图</div>
        </div>

        <div class="function-column">
          <div class="img-wrap">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/function_icon5.png"
              alt=""
            />
          </div>
          <div class="text">经评分析</div>
        </div>

        <div class="function-column">
          <div class="img-wrap">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/function_icon9.png"
              alt=""
            />
          </div>
          <div class="text">商务洽谈方案</div>
        </div>
      </div>
      <img
        class="pc-img"
        src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/product_feature.png"
        alt=""
      />
      <img
        src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/product_pvlayout_feature.png"
        class="mobile-img"
        alt=""
      />
    </div>

    <div class="block-wrap">
      <div class="block-title page-block-title">产品亮点</div>
      <div class="characteristic-box pc-product">
        <div class="characteristic-left">
          <div
            class="characteristic-item"
            :class="{ 'active-item': activeChoose == 'simple' }"
            @mouseover="updateChoose('simple')"
          >
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_icon1.png"
              v-if="activeChoose == 'simple'"
              alt=""
            />
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_icon1_normal.png"
              v-else
              alt=""
            />
            <div class="text">使用零门槛</div>
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/arrow_right.png"
              v-if="activeChoose == 'simple'"
              class="icon_right"
              alt=""
            />
          </div>

          <div
            class="characteristic-item"
            :class="{ 'active-item': activeChoose == 'more' }"
            @mouseover="updateChoose('more')"
          >
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_icon2.png"
              v-if="activeChoose == 'more'"
              alt=""
            />
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_icon2_normal.png"
              alt=""
              v-else
            />
            <div class="text">设计方案由你定义</div>
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/arrow_right.png"
              class="icon_right"
              v-if="activeChoose == 'more'"
              alt=""
            />
          </div>

          <div
            class="characteristic-item"
            :class="{ 'active-item': activeChoose == 'case' }"
            @mouseover="updateChoose('case')"
          >
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_icon3.png"
              v-if="activeChoose == 'case'"
              alt=""
            />
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_icon3_normal.png"
              alt=""
              v-else
            />
            <div class="text">一键输出商务方案</div>
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/arrow_right.png"
              v-if="activeChoose == 'case'"
              class="icon_right"
              alt=""
            />
          </div>

          <div
            class="characteristic-item"
            :class="{ 'active-item': activeChoose == 'mobile' }"
            @mouseover="updateChoose('mobile')"
          >
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_icon3.png"
              v-if="activeChoose == 'mobile'"
              alt=""
            />
            <img
              v-else
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_icon4_normal.png"
              alt=""
            />
            <div class="text">移动助手辅助洽谈</div>
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/arrow_right.png"
              v-if="activeChoose == 'mobile'"
              class="icon_right"
              alt=""
            />
          </div>
        </div>
        <div class="characteristic-right" v-if="activeChoose == 'simple'">
          <div class="characteristic-img-block">
            <div class="img-block" style="width: 343px">
              <div class="text-tips" style="height: 216px">
                <img
                  src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_img1.png"
                  alt=""
                />
              </div>
              <div class="text-block">
                <div>无需专业飞手</div>
                <div>无人机自主飞行采集数据</div>
              </div>
            </div>

            <div class="img-block" style="width: 343px">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_img2.png"
                alt=""
              />
              <div class="text-block">
                <div>无需专业设计人员</div>
                <div>系统可导出CAD设计图</div>
              </div>
            </div>

            <div class="img-block" style="width: 343px">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_img3.png"
                alt=""
              />
              <div class="text-block">
                <div>无需人工排布</div>
                <div>系统自动化排布设计</div>
              </div>
            </div>

            <div class="img-block" style="width: 343px">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_img4.png"
                alt=""
              />
              <div class="text-block">
                <div>无需专业财务人员</div>
                <div>系统配置IRR财务分析模型</div>
              </div>
            </div>
          </div>
        </div>

        <div class="characteristic-right" v-if="activeChoose == 'more'">
          <div class="characteristic-img-block">
            <div class="img-block" style="width: 343px">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_img8.png"
                alt=""
              />
              <div class="text-block">
                <div>自选设备型号</div>
              </div>
            </div>

            <div class="img-block" style="width: 343px">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_img6.png"
                alt=""
              />
              <div class="text-block">
                <div>自定义组件</div>
              </div>
            </div>

            <div class="img-block" style="width: 343px">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_img7.png"
                alt=""
              />
              <div class="text-block">
                <div>多方案择优</div>
              </div>
            </div>

            <div class="img-block" style="width: 343px">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_img5.png"
                alt=""
              />
              <div class="text-block">
                <div>自定义排布规则</div>
              </div>
            </div>
          </div>
        </div>

        <div class="characteristic-right" v-if="activeChoose == 'case'">
          <div class="characteristic-img-block">
            <div class="img-block" style="width: 343px">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_img9.png"
                alt=""
              />
              <div class="text-block">
                <div>项目方案封面</div>
              </div>
            </div>

            <div class="img-block" style="width: 343px">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_img10.png"
                alt=""
              />
              <div class="text-block">
                <div>25年发电量统计</div>
              </div>
            </div>

            <div class="img-block" style="width: 343px">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_img11.png"
                alt=""
              />
              <div class="text-block">
                <div>项目排布效果图</div>
              </div>
            </div>

            <div class="img-block" style="width: 343px">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_img12.png"
                alt=""
              />
              <div class="text-block">
                <div>不同投资模式对比</div>
              </div>
            </div>
          </div>
        </div>

        <div class="characteristic-right" v-if="activeChoose == 'mobile'">
          <div class="characteristic-img-block no-wrap">
            <div class="img-block text-tips-after">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_img13.png"
                alt=""
              />
            </div>

            <div class="img-block">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_img14.png"
                alt=""
              />
            </div>

            <div class="img-block">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_img15.png"
                alt=""
              />
            </div>
          </div>
          <!-- <div style="padding-left:50px;font-size:1.125rem;">
            用移动端可根据洽谈情况实时掌握投资收益，辅助电站精准决策 。
          </div> -->
        </div>
      </div>
      <div class="mobile-product">
        <el-carousel trigger="click" arrow="never" height="480px">
          <el-carousel-item>
            <div class="carousel-item-title">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_icon1.png"
                style="margin-right: 5px"
                alt=""
              />
              使用零门槛
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/arrow_right.png"
                style="margin-left: 10px"
                alt=""
              />
            </div>
            <div class="carousel-row">
              <div class="carousel-column">
                <div class="img-block" style="width: 165px">
                  <div class="text-tips" style="height: 105px">
                    <img
                      src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/mobile/feature_img1.png"
                      alt=""
                    />
                  </div>
                  <div class="text-block">
                    <div>无需专业飞手</div>
                    <div>无人机自主飞行采集数据</div>
                  </div>
                </div>
              </div>
              <div class="carousel-column">
                <div class="img-block" style="width: 165px">
                  <img
                    src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_img2.png"
                    alt=""
                    style="width: 100%"
                  />
                  <div class="text-block">
                    <div>无需专业设计人员</div>
                    <div>系统可导出CAD设计图</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="carousel-row">
              <div class="carousel-column">
                <div class="img-block" style="width: 165px">
                  <img
                    src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_img3.png"
                    alt=""
                    style="width: 100%"
                  />
                  <div class="text-block">
                    <div>无需人工排布</div>
                    <div>系统自动化排布设计</div>
                  </div>
                </div>
              </div>
              <div class="carousel-column">
                <div class="img-block" style="width: 165px">
                  <img
                    src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_img4.png"
                    alt=""
                    style="width: 100%"
                  />
                  <div class="text-block">
                    <div>无需专业财务人员</div>
                    <div>系统配置IRR财务分析模型</div>
                  </div>
                </div>
              </div>
            </div>
          </el-carousel-item>

          <el-carousel-item>
            <div class="carousel-item-title">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_icon2.png"
                style="margin-right: 5px"
                alt=""
              />
              自定义提供更多可能
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/arrow_right.png"
                style="margin-left: 10px"
                alt=""
              />
            </div>
            <div class="carousel-row">
              <div class="carousel-column">
                <div class="img-block" style="width: 165px">
                  <img
                    src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_img5.png"
                    alt=""
                    style="width: 100%"
                  />
                  <div class="text-block">
                    <div>自选设备型号</div>
                  </div>
                </div>
              </div>
              <div class="carousel-column">
                <div class="img-block" style="width: 165px">
                  <img
                    src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_img6.png"
                    alt=""
                    style="width: 100%"
                  />
                  <div class="text-block">
                    <div>自定义组件</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="carousel-row">
              <div class="carousel-column">
                <div class="img-block" style="width: 165px">
                  <img
                    src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_img7.png"
                    alt=""
                    style="width: 100%"
                  />
                  <div class="text-block">
                    <div>多方案择优</div>
                  </div>
                </div>
              </div>
              <div class="carousel-column">
                <div class="img-block" style="width: 165px">
                  <img
                    src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_img8.png"
                    alt=""
                    style="width: 100%"
                  />
                  <div class="text-block">
                    <div>自定义排布规则</div>
                  </div>
                </div>
              </div>
            </div>
          </el-carousel-item>

          <el-carousel-item>
            <div class="carousel-item-title">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_icon3.png"
                style="margin-right: 5px"
                alt=""
              />
              商务洽谈方案
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/arrow_right.png"
                style="margin-left: 10px"
                alt=""
              />
            </div>
            <div class="carousel-row">
              <div class="carousel-column">
                <div class="img-block" style="width: 165px">
                  <img
                    src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_img9.png"
                    alt=""
                    style="width: 100%"
                  />
                  <div class="text-block">
                    <div>项目方案封面</div>
                  </div>
                </div>
              </div>
              <div class="carousel-column">
                <div class="img-block" style="width: 165px">
                  <img
                    src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_img10.png"
                    alt=""
                    style="width: 100%"
                  />
                  <div class="text-block">
                    <div>25年发电量统计</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="carousel-row">
              <div class="carousel-column">
                <div class="img-block" style="width: 165px">
                  <img
                    src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_img11.png"
                    alt=""
                    style="width: 100%"
                  />
                  <div class="text-block">
                    <div>项目排布效果图</div>
                  </div>
                </div>
              </div>
              <div class="carousel-column">
                <div class="img-block" style="width: 165px">
                  <img
                    src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_img12.png"
                    alt=""
                    style="width: 100%"
                  />
                  <div class="text-block">
                    <div>不同投资模式对比</div>
                  </div>
                </div>
              </div>
            </div>
          </el-carousel-item>

          <el-carousel-item>
            <div class="carousel-item-title">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_icon4.png"
                style="margin-right: 5px"
                alt=""
              />
              移动端辅助商务洽谈
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/arrow_right.png"
                style="margin-left: 10px"
                alt=""
              />
            </div>
            <div class="carousel-row" style="justify-content: center">
              <div class="carousel-column">
                <div class="img-block" style="width: 145px">
                  <img
                    src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_img13.png"
                    alt=""
                    style="width: 100%"
                  />
                </div>
              </div>
              <div class="carousel-column">
                <div class="img-block" style="width: 145px">
                  <img
                    src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_img14.png"
                    alt=""
                    style="width: 100%"
                  />
                </div>
              </div>
              <div class="carousel-column">
                <div class="img-block" style="width: 145px">
                  <img
                    src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/feature_img15.png"
                    alt=""
                    style="width: 100%"
                  />
                </div>
              </div>
            </div>
            <div>
              使用移动端可根据洽谈情况实时掌握投资收益，辅助电站精准决策 。
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

    <div class="block-wrap bg-gray">
      <div class="block-title page-block-title">智能AI随身助手“绿能百科”</div>
      <div class="block-desc page-block-desc">
        “绿能百科”融合了先进的人工智能技术和行业专业知识，可实现对光伏知识的快速检索、分析和应用，是专为光伏从业者打造的专属AI智能随身助手和一站式的智能化知识管理平台。
      </div>
      <div class="ai-content">
        <div class="text-row pc-ai-content">
          <div class="column">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/check.png"
              alt=""
            />
            <div class="column-block">
              <div>丰富的知识内容</div>
              <div>光伏领域全覆盖</div>
            </div>
          </div>

          <div class="column">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/check.png"
              alt=""
            />
            <div class="column-block">
              <div>智能化搜索分析</div>
              <div>问题解答更专业</div>
            </div>
          </div>

          <div class="column">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/check.png"
              alt=""
            />
            <div class="column-block">
              <div>支持移动端访问</div>
              <div>获取知识更方便</div>
            </div>
          </div>
        </div>
        <div class="mobile-ai-content">
          <div class="ai-row">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/check.png"
              alt=""
            />
            丰富的知识内容，光伏领域全覆盖
          </div>
          <div class="ai-row">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/check.png"
              alt=""
            />
            智能化搜索分析，问题解答更专业
          </div>
          <div class="ai-row">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/check.png"
              alt=""
            />
            支持移动端访问，获取知识更方便
          </div>
        </div>
        <div class="ai-img-box">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/product_interface1.png"
            style=""
            alt=""
          />
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/product_interface2.png"
            style="width: 24.5rem"
            alt=""
          />
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product_interface3.png"
          />
          <!-- <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/product_interface3.png"
            alt=""
          /> -->
        </div>
      </div>
    </div>

    <div class="block-wrap">
      <div class="block-title page-block-title">快速体验</div>
      <div class="try-block">
        <div style="flex: 1; text-align: center">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/web.png"
            alt=""
          />
          <div>
            网页端直达：<a href="https://cloud.ytusmart.com/"
              >https://cloud.ytusmart.com/</a
            >
          </div>
        </div>
        <div
          style="
            flex: 2;
            display: flex;
            align-items: center;
            justify-content: right;
          "
          class="code-wrap"
        >
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/applet.png"
            class="app-img"
            alt=""
          />
          <div style="margin-left: 2.9rem">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/applet_code.png"
              class="code-img"
              alt=""
            />
            <div style="text-align: center; margin-top: 1.56rem">
              微信小程序码
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";

export default {
  data() {
    return {
      activeChoose: "simple",
    };
  },
  mounted() {
    this.$nextTick(() => {
      new WOW().init();
    });
  },
  methods: {
    updateChoose(data) {
      if (data != this.activeChoose) {
        this.activeChoose = data;
        F;
      }
    },
    toPage() {
      window.open("https://cloud.ytusmart.com/");
    },
  },
};
</script>
<style lang="stylus" scoped>
/deep/.el-carousel__button {
    background-color: #E0E0E0;
}
/deep/.el-carousel__indicator.is-active button {
    background-color:#2372E9;
}
.product-container {
    width:100%;
    .mobile-product {
            display:none;
        }
          .text-tips-after {
            position:relative;
          }
          .text-tips-after::after {
            content:" 用移动端可根据洽谈情况实时掌握投资收益，辅助电站精准决策 。";
            font-size:1.125rem;
            position: absolute;
            left: 17px;
            bottom: -20px;
            white-space: nowrap;
          }
    .img-block {
                // width:45%;

                // padding-left:30px;
                // padding:7px 23px;
                box-sizing:border-box;
                margin-bottom:1rem;
                // display:flex;
                // justify-content:center;
                // align-items:center;
            }
            .text-tips {
                position:relative;
                background-color:#E6E6E6;
                display:flex;
                align-items:center;
                padding-left:20px;
            }
            .text-tips::after {
                content:"大疆无人机";
                position:absolute;
                right:40px;
                top:45px;
            }
            .text-tips::before {
                content:"踏勘精灵APP";
                position:absolute;
                right:20px;
                bottom:40px;
            }
    .layout-banner {
        height:100vh;
        position:relative;
        .mobile-banner {
            display:none;
        }
        @keyframes zoomIn {
            0% {
              transform: scale(1.1);
            }
            100% {
                transform: scale(1);
            }
        }
        img {
          height:100%;
          width: 100%;
          object-fit: cover;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1;
          transition: transform 0.3s ease-out;
          animation: zoomIn 3s ease-out forwards;
        }
        .text-block {
            position:absolute;
            top:50%;
            left:13%;
            transform: translateY(-50%);
            z-index: 2;
            color:#fff;
            .title {
                font-size:3rem;
                letter-spacing: 2px;
                font-weight: bold;
                margin-bottom:1.44rem;
            }
            .desc {
                letter-spacing: 2px;
                width:625px;
                white-space: wrap;
                font-size:1.25rem;
                line-height:35px;
            }
            .use-button {
                width:9rem;
                height:2.875rem;
                font-size:1.125rem;
                letter-spacing:1px;
                cursor:pointer;
                background: #2372E9;
                line-height:2.875rem;
                text-align:center;
                margin-top:6.18rem;
                border-radius:30px;
            }
        }
    }
    .product-block {
      max-width:var(--main-width);
      width:84%;
      margin:0 auto;
    }
    .block-wrap {
        position:relative;
        // width:87.5rem;
        margin:4.625rem auto 2.88rem;
        .block-title {
            position:relative;
            letter-spacing:2px;
            font-weight:bold;
            position:relative;
            text-align:center;
        }
            .block-desc {
                margin:4.625rem auto 3.75rem;
                line-height:32px;
                text-indent:2rem;
            }
            .block-content-row {
                display:flex;
                justify-content:space-between;
                .column-item {
                    width:30%;
                    max-width:28.875rem;
                    box-sizing:border-box;
                    padding-bottom:3rem;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    background: linear-gradient( 180deg, #F3FCFF 0%, #F5F9FF 100%);
                 img {
                    margin-top:2rem;
                 }
                 .text-block {
                    margin-top:1.56rem;
                    margin-bottom:0.812rem;
                    text-align:center;
                    .product-title {
                        font-size:1.5rem;
                        font-weight:bold;
                        color:#333;
                        margin-bottom:13px;
                    }
                    .product-desc {
                        color:#666666;
                        font-size:14px;
                    }
                 }
                }
            }
    }
    .function-list {
        display:flex;
        flex-wrap:wrap;
        margin:7.68rem auto 0;
        max-width:var(--main-width);
        width:84%;
        align-items:center;
        justify-content:space-between;
        .function-column {
            width:27%;
            display:flex;
            align-items:center;
            margin-bottom:3.375rem;
            padding:1.375rem 0 1.375rem 3.5rem;
            box-sizing:border-box;
            .img-wrap {
                margin-right:1.875rem;
                width:65px;
                img {
                  width:100%;
                  height:auto;
                }
            }
            .text {
                font-size:1.375rem;
                color:#333;
                font-weight:bold;
            }
        }
        .function-column:hover {
            box-shadow: 0px 4px 20px 0px rgba(40,40,40,0.08);
            border-radius: 18px 18px 18px 18px;
        }
    }
    .pc-img {
        width:60%;
        margin:0 auto 10rem;
        display:block;
    }
    .mobile-img {
        display:none;
      }
    .bg-wrap {
        background-image:url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/product_bg2.png");
        background-size:cover;
        width:100%;
        display:flex;
        margin-bottom:0 !important;
        flex-direction:column;
    }
    .characteristic-box {
        display:flex;
        max-width:var(--main-width);
        width:84%;
        margin:6.375rem auto 0;

       .characteristic-left {
        flex:1;
        .characteristic-item {
            display:flex;
            align-items:center;
            margin-bottom:6.375rem;
            .text {
                margin:0 15px;
                font-size:1.5rem;
                font-weight:bold;
                color:#333;
            }
            .icon_right {
                height:16px;
            }
        }
        .active-item {
            .text {
            color:#2372E9 !important;
        }
        }
       }
       .characteristic-right {
        flex:2;
        .no-wrap {
            display:flex !important;
            flex:3 !important;
            flex-wrap:nowrap !important;
            .img-block {
                margin-right:0px !important;
            }
        }
        .characteristic-img-block {
            display:flex;
            justify-content:right;
            flex-wrap:wrap;

            .img-block:nth-child(2n-1) {
                margin-right:1.88rem;
            }
            .text-block {
                text-align:center;
                div:nth-child(1) {
                    margin-top:16px;
                    margin-bottom:5px;
                }
            }
        }
       }
    }
    .bg-gray {
        max-width:100% !important;
        background-color:#F5F7FA;
        padding:4.18rem 0 5.18rem;
        background-image:url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/product_bg3.png");
        background-size:cover;
        margin-bottom:0 !important;
        .block-title {
            margin-bottom:3.875rem;
            letter-spacing:2px;
            font-weight:bold;
        }
        .block-desc {
            width:1000px;
            margin:0 auto 4.18rem;
            text-align:center;
        }
    }
    .ai-content {
        max-width:var(--main-width);
        width:84%;
        margin:0 auto;
        .mobile-ai-content {
            display:none;
        }
        .text-row {
            display:flex;
            justify-content:space-between;
            margin-bottom:3.625rem;
            .column {
                display:flex;
                align-items:flex-start;
                img {
                    margin-right:15px;
                }
                .column-block {
                    font-size:1.5rem;
                    font-weight:bold;
                    color:#333333;
                    div:nth-child(1) {
                        margin-bottom:10px;
                    }
                }
            }
        }
        .ai-img-box {
            display:flex;
            justify-content:center;
            img:not(:last-child) {
                margin-right:3.375rem;
            }
            img:nth-child(2n-1) {
                width:21.875rem;
                height:43.125rem;
                margin-top:1.8125rem
            }
        }
    }
    .try-block {
        display:flex;
        max-width:var(--main-width);
        width:84%;
        margin:3.56rem auto 0;
        a {
            color:#2372E9;
        }
    }
}
@media only screen and (max-width: 1200px) and (min-width: 768px) {
    .block-content-row {
        flex-wrap:wrap;
        .column-item {
            margin-bottom:30px;
        }
    }
    .function-list {
        white-space:nowrap;
        padding:0 30px;
        .function-column {
            flex-wrap:wrap;
        }
    }
}
@media only screen and (max-width: 768px) {
  .product-container {
    .mobile-banner {
        display:block !important;
        width:100%;
    }
    .pc-banner {
        display:none;
    }
    .layout-banner {
        margin-top:103px;
        height:380px !important;
        background-image:url('https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/product_pvlayout_banner_mobile.png');
        background-size:cover;

        .text-block {
            transform:translateY(0);
            top:52px;
            .desc {
              line-height:22px;
              font-size:14px;
              }
            .title {
            font-size:24px;
            margin-bottom:10px ;
        }
        }
        .use-button {
            display:none;
        }
    }
    .block-wrap {
    .block-content-row {
        justify-content:space-between ;
        padding-top:26px;
        .column-item {
            padding-bottom:0 ;
            height:auto;
            width:30%;
            padding-bottom:20px;
            margin-right:0;
            font-size:18px;
            img {
              width:77px;
              margin-top:-3rem;
            }
            .text-block {
              margin-top:0.7rem;
                .product-title {
                    font-size:18px;
                }
                .product-desc {
                  font-size:10px;
                }
            }
        }
    }
    }
    .bg-wrap {
      width:auto !important;
    }
    .function-list {
        white-space:nowrap;
        .function-column {
            flex-wrap:wrap;
            display:block !important;
        }
    }
    .block-wrap {
        padding:0 15px;
        margin:0px;
        width:auto;
        .block-title {
            font-size:22px !important;
            padding:38px 0 0px;
            margin:0;
        }
        .block-title::after {
            top:40px !important;
        }
            .block-desc {
            width:auto ;
            padding:0 15px 26px;
            font-size:14px;
            margin-bottom:10px;
            line-height:20px;
            margin-top:8px;
            color:#666;
        }
    }
    .function-list {
        margin-top:42px;
        width:auto;
        .function-column {
            text-align:center;
            padding:0;
            justify-content:center;
            margin-bottom:30px;
            .text {
                font-size:15px;
                margin-top:10px;
            }
            .img-wrap {
                margin-right:0 !important;
                width:100%;
                img {
                  width:65px;
                }
            }
        }

    }
    .pc-img {
            display:none ;
        }
        .mobile-img {
          display:block;
          padding-bottom:60px;
        }
        .pc-product {
            display:none !important;
        }
        .mobile-product {
            display:block !important;
            margin-top:43px;
            .carousel-item-title {
                color:#2372E9;
                font-size:18px;
                display:flex;
                margin-bottom:20px;
                align-items:center;
            }
            .carousel-row {
                display:flex;
                justify-content:space-between;
                .img-block {
                    padding:0 !important;
                }
                .text-tips::before {
                    bottom:16px !important;
                    right:4px !important;
                }
                .text-tips::after {
                    top:12px !important;
                    right:14px !important;
                }
                .text-block {
                    margin-top:10px;
                    text-align:center;
                }
            }
        }

        .pc-ai-content {
            display:none !important;
        }
        .ai-content {
          width:auto !important;
        }
        .mobile-ai-content {
            display:block !important;
            margin-bottom:32px !important;
            .ai-row {
                display:flex;
                justify-content:center;
                align-items:center;
                margin-bottom:15px;
                font-weight:bold;
                color:#222;
                img {
                    width:18px;
                    margin-right:7px;
                }
            }
        }
        .ai-img-box {
             padding-bottom:15px;
                img:nth-child(2n-1) {
                    width: 101px !important;
                    height: 223px !important;
                    margin-right:15px !important;
                }
                img:nth-child(2) {
                    width:114px !important;
                    margin-right:15px !important;
                }
            }
            .try-block {
                margin-top:0px;
                display:block;
                width:auto;
                img {
                  width:300px;
                }
                > div {
                  margin-right:0 !important;
                  margin-bottom:50px;
                }
                .app-img {
                  width:118px !important;
                }
                .code-img {
                  width:167px !important;
                }
            }
            .code-wrap {
                justify-content:center;
                margin:26px 0 29px;
            }
            .text-tips {
              padding-left:0px !important;
              img {
                width:65px;
              }
            }
            }
}
</style>
